export default function TabList(){
    return {
        styleOverrides: {
            flexContainer: {
                gap: 0
            }
        }
    }
}